import { Link } from "react-router-dom";
import { t } from "../i18n";

const LINKS = [
  ["/mentions-legales", "legal.mentions", "footer-mentions-link"],
  ["/confidentialite", "legal.privacy", "footer-privacy-link"],
  ["/cgv", "legal.cgv", "footer-cgv-link"],
];

export const Footer = ({ dark = false }) => (
  <footer className={`relative z-10 px-4 pb-8 pt-4 text-center text-sm font-semibold ${dark ? "text-white/40" : "text-white"}`} data-testid="site-footer">
    <div className={`mx-auto inline-block rounded-[24px] px-5 py-2 ${dark ? "" : "bg-[#1E2A5A]/45 backdrop-blur-md"}`}>
    <nav className="flex flex-wrap justify-center gap-x-5 gap-y-1">
      {LINKS.map(([to, label, id]) => (
        <Link key={to} to={to} data-testid={id} className="underline-offset-4 hover:underline py-2">{t(label)}</Link>
      ))}
    </nav>
    <p className={`mt-1 ${dark ? "" : "opacity-90"}`}>© MIZUBINI · Sans publicité · Aucun compte enfant</p>
    <p className={`mt-1 text-xs font-medium ${dark ? "" : "opacity-80"}`} data-testid="footer-credit">
      Site réalisé par le{" "}
      <a href="https://www.eminenz.fr" target="_blank" rel="noopener noreferrer" data-testid="footer-eminenz-link"
        className="inline-block py-1 underline underline-offset-4 hover:opacity-100">studio EMINENZ</a>
    </p>
    </div>
  </footer>
);
